import { engineRequest, verticalRequest } from './http';

// Paged, newest first. Query: `status` (one or a comma list), `site_id`,
// `category`, `member_id`, `sla` (`on_track` | `at_risk` | `breached`),
// `source`, `search`, `created_from`, `created_to` (local dates, inclusive),
// `page`, `page_size`. Open to any account member.
export const listTickets = params =>
  engineRequest({ path: '/tickets', params });

// The same filters (no paging) as a csv or xlsx file. Administrators only;
// 422 `export_too_large` over 20,000 rows. Answers a Blob.
export const exportTickets = (params, format = 'csv') =>
  engineRequest({
    path: '/tickets/export',
    params: { ...params, format },
    responseType: 'blob',
  });

export const getTicket = id => engineRequest({ path: `/tickets/${id}` });

// `{to, reason?, note?}`: `to` is a status or a step name. Answers
// `{from_status, to_status, ticket}`.
export const patchTicketStatus = (id, body) =>
  engineRequest({ method: 'patch', path: `/tickets/${id}/status`, data: body });

// Answers `{changed, visits, ticket}`; `visits` is null when nothing changed.
export const putTicketAssignee = (id, memberId) =>
  engineRequest({
    method: 'put',
    path: `/tickets/${id}/assignee`,
    data: { member_id: memberId },
  });

// Admin only. `files` are image Files (jpeg, png, webp); one `files` part each.
// All or nothing: 413 `file_too_large`, 415 `unsupported_file_type`, 422
// `too_many_photos`. Answers `{media: [rows]}`. Engine prefix, not the
// co-living one the manual create uses.
export const uploadTicketMedia = (id, files) => {
  const form = new FormData();
  files.forEach(file => form.append('files', file));
  return engineRequest({
    method: 'post',
    path: `/tickets/${id}/media`,
    data: form,
  });
};

// Admin only; 204. Works for portal and chat photos.
export const deleteTicketMedia = (id, mediaId) =>
  engineRequest({ method: 'delete', path: `/tickets/${id}/media/${mediaId}` });

// Admin only. Puts the ticket in any status the detail's `allowed_statuses`
// lists, silently (no message to anyone). Body `{to, reason}`; answers
// `{from_status, to_status, reopened, tell: {tenant, pic}, ticket}`.
export const postTicketSetStatus = (id, body) =>
  engineRequest({
    method: 'post',
    path: `/tickets/${id}/set-status`,
    data: body,
  });

// What reassigning would do to the visits. Writes nothing.
export const getAssigneePreview = (id, memberId) =>
  engineRequest({
    path: `/tickets/${id}/assignee-preview`,
    params: { member_id: memberId },
  });

// Partial `{eta, tenant_note, internal_note}`; null clears. Answers the ticket.
export const putTicketNotes = (id, body) =>
  engineRequest({ method: 'put', path: `/tickets/${id}/notes`, data: body });

// Admin only (agents get 403): one row per WhatsApp send or bell notification.
export const listTicketMessages = id =>
  engineRequest({ path: `/tickets/${id}/messages` });

// Manual create for walk-in and phone issues. Answers 201
// `{result: 'created' | 'reopened' | 'needs_admin', ticket}`; 409
// `duplicate_open_ticket` carries the open ticket in `detail.ticket`.
export const createManualTicket = fields =>
  verticalRequest({ method: 'post', path: '/tickets', data: fields });
